import { isSameRoute } from './utils.js'
import utils from '@/lib/utils'

function perfect (node, parent, router) {
  if (!parent) {
    node.class = 'text-white' // `text-module-${node.name}`
  }
  node.parent = parent
  node.path = parent?.path ? `${parent.path}.${node.name}` : node.name
  node.level = parent === undefined ? 0 : parent.level + 1
  node.class = node.class === undefined ? parent?.class : node.class
  node.iconClass = node.iconClass === undefined ? parent?.iconClass : node.iconClass
  if (node.link?.to && router?.resolve) {
    node.link.resolved = router.resolve(node.link.to)
  }
}

function enumerate (nodes, callback, parent) {
  for (const node of nodes) {
    let result = callback(node, parent)
    if (result !== undefined) {
      return result
    }
    if (node.children) {
      result = enumerate(node.children, callback, node)
      if (result !== undefined) {
        return result
      }
    }
  }
}

var _installed = false

export default class Menu {
  static install (Vue, { router }) {
    if (_installed === true) return
    _installed = true

    const menu = new Menu(router)
    // Vue.mixin({
    //   computed: {
    //     // 注意：在data()函数中不能使用computed属性
    //     $menuNode () {
    //       return menu.match(this.$route)
    //     }
    //   }
    // })
    Object.defineProperties(Vue.prototype, {
      $menu: {
        get () {
          return menu
        }
      },
      $menuNode: {
        get () {
          let menuNodeCache = this.__menuNodeCache
          if (!menuNodeCache) {
            menuNodeCache = { }
            this.__menuNodeCache = menuNodeCache
          }
          if (menuNodeCache.route === this.$route) {
            return menuNodeCache.menuNode
          } else {
            const menuNode = menu.match(this.$route)
            menuNodeCache.route = this.$route
            menuNodeCache.menuNode = menuNode
            return menuNode
          }
        }
      }
    })
  }

  constructor (router) {
    // 血源档案
    const reservation = {
      name: 'reservation',
      icon: 'auto_stories',
      text: '智慧献血屋',
      opened: false,
      children: [
        {
          name: 'info',
          // icon: 'pending_actions',
          text: '预约信息',
          link: {
            to: {
              path: '/reservation/info'
            }
          }
        }
      ]
    }

    // 管理
    const manage = {
      name: 'manage',
      icon: 'opacity',
      text: '管理',
      opened: false,
      children: [{
        name: 'collectPoint',
        // icon: 'invert_colors',
        text: '采血点管理',
        link: {
          to: {
            path: '/manage/collectPoint'
          }
        }
      }, {
        name: 'advertising',
        // icon: 'battery_full',
        text: '小程序内容编辑',
        link: {
          to: {
            path: '/manage/advertising'
          }
        }
      }, {
        name: 'reservation',
        // icon: 'precision_manufacturing',
        text: '预约管理',
        link: {
          to: {
            path: '/manage/reservation'
          }
        }
      }]
    }
    const nodes = [
      reservation,
      manage
    ]
    const nodesMap = Object.create(null)
    enumerate(nodes, (node, parent) => {
      perfect(node, parent, router)
      nodesMap[node.path] = node
    })
    // 字段
    this.nodes = utils.deepFreeze(nodes)
    this.nodesMap = Object.freeze(nodesMap)
  }

  forEach (callback) {
    return enumerate(this.nodes, callback)
  }

  match (route) {
    if (!route) return
    return this.forEach(node => {
      const resolvedRoute = node.link?.resolved?.route
      if (resolvedRoute) {
        if (isSameRoute(route, resolvedRoute)) {
          return node
        }
      }
    })
  }
}
